import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const LoginLayout = loadable(() => import('./login.layout'), {
  fallback: <FullPageLoader />,
});
